document.addEventListener("turbolinks:load", function () {
  $("select2").select2({
    allowClear: true,
  });
});
